import { MDBCard, MDBCardBody, MDBIcon } from 'mdb-react-ui-kit';
import { useMemo } from 'react';
import { Data } from '../../../../../../../service/global';
import { StatusIcon } from '../../../../../../../components/StatusIcon';
import {
    PrizeBoxIndividualDoorItem,
    PrizeBoxIndividualDoorItemProps,
} from './PrizeBoxIndividualDoorItem';
import { PrizeBoxDTO } from '@scm/common-legacy';

export interface PrizeBoxItemProps {
    box: PrizeBoxDTO;
    onSelect: () => void;
}

export const PrizeBoxItem = ({ box, onSelect }: PrizeBoxItemProps) => {
    const bg = useMemo(
        () => Data.esList[box.status[0]?.id]?.web?.level,
        [box, box.status, Data, Data.esList],
    );

    return (
        <div className="d-inline-block pt-3 pb-3 ps-1 pe-1" onClick={onSelect}>
            <MDBCard
                className={`d-inline-block card-hover2 bg-opacity-25 bg-${bg}`}
            >
                <div
                    className="position-absolute d-flex justify-content-center w-100"
                    style={{ top: 0, marginTop: -10 }}
                >
                    <span className="badge rounded-pill badge-primary">
                        {box.id + 1}
                    </span>
                </div>
                <MDBCardBody className="p-2 mt-1">
                    <div className="d-flex flex-column">
                        <div className="d-flex flex-row">
                            <div className="d-flex flex-column">
                                {box.doors
                                    .slice(0, Math.floor(box.doors.length / 2))
                                    .map((d) => (
                                        <PrizeBoxIndividualDoorItem
                                            key={d.id}
                                            {...d}
                                        />
                                    ))}
                            </div>
                            <div className="d-flex flex-column">
                                {box.doors
                                    .slice(Math.floor(box.doors.length / 2))
                                    .map((d) => (
                                        <PrizeBoxIndividualDoorItem
                                            key={d.id}
                                            {...d}
                                        />
                                    ))}
                            </div>
                        </div>
                        <div className="d-flex flex-row w-100 justify-content-center">
                            {box.status.map((s) => (
                                <StatusIcon
                                    key={s.id}
                                    name={s.id}
                                    ts={s.ts}
                                    count={s.count}
                                />
                            ))}
                        </div>
                    </div>
                </MDBCardBody>
            </MDBCard>
        </div>
    );
};
